import { searchWords } from '~/utils/search-text'

export type HighlightSegment = { text: string, match: boolean }

/** Un caractère tel que la recherche le compare : sans accent, en minuscules. */
function fold(char: string): string {
  return char.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
}

/**
 * Découpe `text` en segments marqués là où figure un mot de `query` (#109).
 *
 * La comparaison se fait sur le texte replié (sans accents ni casse), comme
 * `matchesQuery`, mais les segments rendus sont ceux du texte **d'origine** :
 * chercher « ecole » doit surligner « École », pas « ecole ». Chaque caractère
 * replié garde l'indice du caractère d'origine dont il vient ; un caractère qui
 * se replie en rien (accent combinant) suit le marquage de celui qu'il décore.
 */
export function highlightMatches(text: string, query: string): HighlightSegment[] {
  const chars = Array.from(text)
  const owners: number[] = []
  const folded = chars.map((char, index) => {
    const f = fold(char)
    for (let i = 0; i < f.length; i++) owners.push(index)
    return f
  }).join('')

  const marked = chars.map(() => false)
  for (const word of searchWords(query)) {
    for (let at = folded.indexOf(word); at !== -1; at = folded.indexOf(word, at + 1)) {
      for (let i = at; i < at + word.length; i++) marked[owners[i] ?? 0] = true
    }
  }
  chars.forEach((char, index) => {
    if (index > 0 && fold(char) === '') marked[index] = marked[index - 1] ?? false
  })

  const segments: HighlightSegment[] = []
  chars.forEach((char, index) => {
    const match = marked[index] ?? false
    const last = segments.at(-1)
    if (last && last.match === match) last.text += char
    else segments.push({ text: char, match })
  })
  return segments.length > 0 ? segments : [{ text, match: false }]
}
